var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 280,
    viewBox: "0 0 220 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 280,
    rx: 17,
    fill: "#949494"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166 183.556V96.4444C166 89.6 160.4 84 153.556 84H66.4444C59.6 84 54 89.6 54 96.4444V183.556C54 190.4 59.6 196 66.4444 196H153.556C160.4 196 166 190.4 166 183.556ZM90.7111 152.32L103.778 168.062L123.067 143.236C124.311 141.618 126.8 141.618 128.044 143.298L149.884 172.418C151.44 174.471 149.947 177.396 147.396 177.396H72.7911C70.1778 177.396 68.7467 174.409 70.3644 172.356L85.8578 152.444C87.04 150.827 89.4044 150.764 90.7111 152.32Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/imagePlaceholder.d68729e4bedcf370a24657c64b4a97c5.svg";
export { ForwardRef as ReactComponent };